export const forgotPassword = {
  title: 'Passwort vergessen',
  resetPasswordButton: 'Passwort zurücksetzen',
}
